import { useEffect } from "react";
import "./PagePlaceholder.scss";

/**
 * 页面占位组件：目前只渲染标题 + 一句占位说明。
 * 各菜单页面复用它，等后续再填充真实内容。
 */
const PagePlaceholder: React.FC<{ title: string }> = ({ title }) => {
  useEffect(() => {
    document.title = `${title} | CloudStore API`;
  }, [title]);

  return (
    <div className="cs-placeholder">
      <h1 className="cs-placeholder__title">{title}</h1>
      <div className="cs-placeholder__coming">
        <span className="cs-placeholder__coming-badge">Coming soon</span>
        <p className="cs-placeholder__coming-desc">
          This page is under construction and will be available soon.
        </p>
      </div>
    </div>
  );
};

export default PagePlaceholder;
